import VendorTypeComponent from "../components/VendorType";
import { useAppSelector } from "../hooks";

function VendorTypes() {
  const vendorTypes = useAppSelector((state) => state.app.vendorTypes);

  return (
    <>
      <div id="vendor-types" className="vendor-types">
        <div className="header-container">
          <h1>VENDORS</h1>
        </div>

        <div className="types-container">
          {vendorTypes.map((type) => (
            <VendorTypeComponent vendorType={type} key={type.id} />
          ))}
        </div>
      </div>
    </>
  );
}

export default VendorTypes;
